import { isStr } from "../../utils/utils";

export const validateContent = (svgContent: string | null) => {
    if (svgContent && typeof document !== "undefined") {
        const div = document.createElement("div");
        div.innerHTML = svgContent;

        // setup this way to ensure it works on IE
        for (let i = div.childNodes.length - 1; i >= 0; i--) {
            if (div.childNodes[i].nodeName.toLowerCase() !== "svg") {
                div.removeChild(div.childNodes[i]);
            }
        }

        // must only have 1 root element
        const svgElm = div.firstElementChild;
        if (svgElm && svgElm.nodeName.toLowerCase() === "svg") {
            const svgClass = svgElm.getAttribute("class") || "";
            svgElm.setAttribute("class", (svgClass + " ux-icon__svg").trim());
            svgElm.removeAttribute("id");

            // remove title element to prevent a bug where the svg title was treated as the page title
            const title = svgElm.querySelector("title");
            if (title !== null) {
                title.remove();
            }

            // root element must be an svg
            // lets double check we've got valid elements
            // do not allow scripts
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            if (isValid(svgElm as any)) {
                return div.innerHTML;
            }
        }
    }
    return "";
};

export const isValid = (elm: HTMLElement) => {
    if (elm.nodeType === 1) {
        if (elm.nodeName.toLowerCase() === "script") {
            return false;
        }

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < elm.attributes.length; i++) {
            const attr = elm.attributes[i];
            if (typeof attr !== "undefined") {
                const val = elm.attributes[i].name;
                if (isStr(val) && val.toLowerCase().indexOf("on") === 0) {
                    return false;
                }
            }
        }

        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let i = 0; i < elm.childNodes.length; i++) {
            /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
            if (!isValid(elm.childNodes[i] as any)) {
                return false;
            }
        }
    }
    return true;
};
